import { AxiosError } from 'axios';

import { TERRITORIES_API_URL } from '@/constants/apis';
import { configuration } from '@/constants/config';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';
import { Territory } from '@/types/territories/territory.type';

export interface GetTerritoriesParams {
  search?: string;
}

export const getTerritories = async (
  params?: GetTerritoriesParams
): Promise<ApiResponse<Territory[]>> => {
  try {
    const response = await apiManager.get(TERRITORIES_API_URL, {
      baseURL: configuration.TERRITORIES_API_URL,
      headers: { 'Content-Type': 'application/json' },
      params: {
        ...(params?.search && {
          search: params.search,
        }),
      },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
